import { Layout } from "@mcleod/components";
import { AutogenLayoutCustomerFscQuickInfo } from "./autogen/AutogenLayoutCustomerFscQuickInfo";

export class CustomerFscQuickInfo extends AutogenLayoutCustomerFscQuickInfo {
    public static get fuelSurchargePaySearchMethod(): (layout: Layout, keyValue: any) => Promise<void> {
        return async (layout: Layout, keyValue: any) => {
            await layout.mainDataSource?.search({ fuel_surcharge_pay_id: keyValue });
        };
    }
}
